export default "{\n\n\n    \"key\": \"value\"\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n}\n"